//	+-----------------------------------------------+
//	| Data Box Controller Object					|
//	+-----------------------------------------------+

/**
 * @file cardboard/dataBoxController.js
 * @module cardboard/dataBoxController
 * @desc This module provides the DataBoxController class, which is the business
 * logic and mediator between data models and view objects.
 * @author Geoffrey Pursell
 */

define('cardboard/dataBoxController',[
        // libraries
        "jquery", "underscore", "backbone", "rsvp",

        // app modules
        "models", "cardboard/baseController", "cardboard/models", "cardboard/collections", "commonDataSources", "cardboard/databoxes",
        "cardboard/util", "cardboard/pluginHelper"
    ],
    function ($, _, Backbone, RSVP,
        RCModels, BaseController, Models, Collections, CommonDataSources, DataBoxViews,
        Util, PluginHelper) {

        console.log("MODULE: cardboard/dataBoxController");
        window.indexDataBox = 0;

        var Promise = RSVP.Promise;

        /**
         * @constructor
         * @alias module:cardboard/dataBoxController
         */
        var DataBoxController = function () {
            this.initialize.apply(this, arguments);
        };

        Util.inherit(BaseController, DataBoxController, /** @lends module:cardboard/dataBoxController.prototype */ {

            // EVENT HANDLERS
            globalEvents: {
                "reportSet": "onReportSet"
            },

            initialize: function (params) {
                var pluginOptions = PluginHelper.getCurrentPluginOptions(),
                    orgId = (params ? params.orgId : null),
                    self = this;

                /** has of all data source instances associated with this databox
                 * @type Object	 */
                this.dataSources = {};
                /** has of all filter source instances associated with this plugin
                 * @type Object	 */
                this.filterSources = {};

                /** keep track of whether or not data (NOT filter sources) has been
                 * loaded
                 * @type Boolean
                 */
                this.dataLoaded = false;
                this.isCollegeReport = false;
                this.isCollegePrevReport = false;
                this.index = indexDataBox++;
                // hydrate the data source info objects into real, working Backbone
                // Models
                this.prepareDataAndFilterSources();

                /** the view object for this databox
                 * @type DataBoxViews.DataBoxView */
                this.view = new DataBoxViews.DataBoxView(this.dataSources, this.filterSources, this);
                this.view.render(params);

                // Load 'em up. This is the first load of filters for this data box,
                // so we've either been created from nothing, or we've been given
                // parameters by a deep link. Either way, we need an orgId to pass
                // to the filter services.
                this.loadReportFilterSources(orgId || RCModels.defaultOrg.orgID)
                    .then(function () {
                        self.view.updateConfigDrawerView();
                        self.view.on("filterChangedAutomatically", self.onFilterChangedAutomatically, self);

                        // special noDefaultOrg behavior: we're not loading Statewide right
                        // away, so set a placeholder title and pop open the drawer to
                        // prompt for a school.
                        // 
                        // if we have params, it means we need to render the given dataset
                        // immediately, so noDefaultOrg has no meaning and we shouldn't pop
                        // the drawer open.

                        if (pluginOptions.noDefaultOrg && (!params || !params.orgId)) {
                            self.setNoOrg();
                            self.view.setPlaceholderSummary();
                            _.delay(self.view.openDrawer.bind(self.view), 1900);
                        }

                        // if we have given params, we need to set the filters
                        // correctly from them and load the data. if not, load the
                        // default, unless the plugin says not to.  we do this
                        // before we attach event listeners so we don't thrash the
                        // view.
                 
                        if (params) {
                            // yup, we're changing the org and filters here

                            if (params.ECODEVREGION && params.ECODEVREGION != "FOC_NONE") {
                                params.orgId = "999999000";
                                params.groupType = "state";
                            }
                          
                            self.setViewStateFromParams(params);
                            self.loadReportDataSources();
                        } else if (!pluginOptions.noDefaultOrg) {
                            // the filters will naturally be in their default states
                            self.setDefaultOrg();
                            self.view.updateSummary();
                            self.loadReportDataSources();
                        }

                        // attach declarative events
                        self.attachGlobalEvents();

                        // if the data box view's setting change, we REALLY need to
                        // know. we're in charge of refreshing the data model!
                        self.view.on("filterChanged", self.onFilterChanged, self);
                        self.view.on("orgChanged", self.onOrgChanged, self);
                        self.view.on("destroy", self.destroy, self);
                    })
                    .then(null, Util.reportPromiseException);
            },

            destroy: function (options) {
                this.stopListeningToGlobalEvents();
                Backbone.trigger("dataBoxDestroyed", this, options);
                this.view.off(null, null, this);
                this.view.destroy();
                this.view = null;
                // it's the workspace controller's repsonsibility to remove this
                // controller from its array of controllers, not ours

                return this;
            },

            // whenever any kind of config setting changes in a databox
            onSettingChanged: function ( /*info*/ ) {

            },
            /** event handler: a filter has changed */
            onFilterChanged: function (info) {

                if (info.menuElement != null) {
                    
                    if ((info.menuElement.id === "box_FISCAL_YEAR") || (info.menuElement.id === "box_COHORTID") || (info.menuElement.id === "box_devEdCOHORTID")) {
                        this.view.setFY(info.selection.code);
                    } else if ((info.menuElement.id === "box_subject") && (info.selection.code == "S")) {
                        $(info.menuElement.form).find('select[name="accountabilityFlg"]').val('FOC_NONE').change();
                    }
                    else if (info.menuElement.id === "box_graduationYearRate")  {
                        if((info.menuElement.value === "5") || (info.menuElement.value === "6")){
                            $(info.menuElement.form).find('select[name="nscomparisonline"]').val('FOC_NONE').change();
                            $(info.menuElement.form).find('select[name="GroupAverage"]').val('N').change();
                            $(info.menuElement.form).find('#GroupAverage').hide();
                            $(info.menuElement.form).find('#nscomparisonline').hide();
                        }
                        else{
                           $(info.menuElement.form).find('#GroupAverage').show();
                           $(info.menuElement.form).find('#nscomparisonline').show();
                        }
                    }
                    else if (info.menuElement.id === "box_GroupAverage")  {
                        if(info.menuElement.value === "Y") {
               
                            $(info.menuElement.form).find("input:checkbox").prop('checked', false).change();
                            $(info.menuElement.form).find("label").removeClass( "ui-checkbox-on" ).addClass( "ui-checkbox-off" );

                             $(info.menuElement.form).find('#FosterCare').hide();
                            $(info.menuElement.form).find('#specialPop').hide();
                            $(info.menuElement.form).find('#gender').hide();
                            $(info.menuElement.form).find('#ethnicity').hide(); 
                        }
                        else{
                            $(info.menuElement.form).find('#FosterCare').show();
                            $(info.menuElement.form).find('#specialPop').show();
                            $(info.menuElement.form).find('#gender').show();
                            $(info.menuElement.form).find('#ethnicity').show();
                        }
                    }
                } else if (info.optionElement != null) {

                    if ((info.optionElement.id === "box_FosterCare_FostercareFiscalyear") || (info.optionElement.id === "box_FosterCare_FostercareInHighScho") || (info.optionElement.id === "box_FosterCare_FostercareEver") || (info.optionElement.id === "box_ethnicity_StateamIndian") ) {
                        if (info.optionElement.checked) {

                            jQuery(info.optionElement).closest("form").find("input:checkbox").prop('checked', false);
                            info.optionElement.checked = true;

                        } else {
                            info.optionElement.checked = false;
                        }
                    } else if ((location.hash.indexOf("assessmentsParticipation") > -1) || (location.hash.indexOf("graduation") > -1) || (location.hash.indexOf("ACCESS") > -1)) {
                        if (info.optionElement.checked) {
                            jQuery(info.optionElement).closest("form").find("#box_FosterCare_FostercareEver").prop('checked', false);
                            jQuery(info.optionElement).closest("form").find("#box_FosterCare_FostercareFiscalyear").prop('checked', false);
                            jQuery(info.optionElement).closest("form").find("#box_FosterCare_FostercareInHighScho").prop('checked', false);
                            jQuery(info.optionElement).closest("form").find("#box_ethnicity_StateamIndian").prop('checked', false);    
                            info.optionElement.checked = true;
                        }
                    }

                }

                this.view.updateFilterMenus();
                this.executeFilterActions(info);

                // BIG DEAL: we might need to swap out an entire pane based on
                // filter conditions.
                this.view.updatePaneViews();
                // this.view.updateSummary();
                //this.loadReportDataSources();

                var pluginOptions = PluginHelper.getCurrentPluginOptions();

                // as soon as you change the org, filter selections *and*
                // all data views are invalid, so we should mask them.
                this.view.maskContentForLoading();

                // if this is MMR or some other plugins that takes separate
                // parameters rather than a single org ID, we have to ask the view
                // to split the orgID apart into its constituent parts and put them
                // in hidden fields.
                this.view.splitOrgID();
                var selectionState = this.view.getConfigSelections();

                this.loadReportFilterSources(info.orgID)
                    .then(function () {
                        this.view.updateFilterMenus(selectionState);
                        //  if (this.dataSources.data.url.indexOf("sleds") > -1) {
                        this.view.updateDemoCats(selectionState);
                        //  }
                        // new: show the filters and demo cats; they may have been
                        // hidden if no org was selected.
                        this.view.drawerView.showFiltersAndDemoCats();
                        this.view.updateSummary();
                        return this.loadReportDataSources();
                    }.bind(this))
                    .then(function () {
                        this.view.unmaskContentForLoading();
                    }.bind(this))
                    .then(null, Util.reportPromiseException);

                this.executeFilterActions(info);

                // this lets the main workspace controller know it needs to refresh the URL
                Backbone.trigger("filterChanged");
                //   Backbone.trigger("orgChanged");
                if (this.dataSources.data.url.indexOf("newcollegestudentdemographics") > -1 || this.dataSources.data.url.indexOf("newcollegestudentenrollment") > -1 || this.dataSources.data.url.indexOf("collegegraduates") > -1 || this.dataSources.data.url.indexOf("electivestoactresults") > -1 || this.dataSources.data.url.indexOf("collegeActivity") > -1 || this.dataSources.data.url.indexOf("highSchoolAcademics") > -1 || this.dataSources.data.url.indexOf("stayingInAndCompletingCollege") > -1 || this.dataSources.data.url.indexOf("deveducation") > -1  || this.dataSources.data.url.indexOf("HSGraduatesToEmployment") > -1 || this.dataSources.data.url.indexOf("outstatecollege") > -1) {
                    if (info.menuElement != null) {
                        if ((info.menuElement.id === "box_collegeGraduatesCOHORTID") || (info.menuElement.id === "box_newCollegeStudentDemographicsCOHORTID") || (info.menuElement.id === "box_newCollegeStudentEnrollmentCOHORTID") || (info.menuElement.id === "box_electivesToACTResultsCOHORTID") || (info.menuElement.id === "box_collegeActivityCOHORTID") || (info.menuElement.id === "box_COHORTID") || (info.menuElement.id === "box_completingCollegeCOHORTID") || (info.menuElement.id === "box_devEdCOHORTID") || (info.menuElement.id === "box_outStateCollegeCOHORTID")  || (info.menuElement.id === "box_hsGradEmploymentCOHORTID")) {
                            Backbone.trigger("reportSet");
                        }
                    }
                }

            },
            /** this is needed only when a filter is set by
             * DataBoxes.FilterMenusView.updateMenus(), because when it does that,
             * we need to execute filter actions */
            onFilterChangedAutomatically: function (info) {
                this.executeFilterActions(info);
                this.view.updatePaneViews();
            },

            /** event handler: the selected organization has changed.
             * @param info not sure right now what this is. TODO: find out*/
            onOrgChanged: function (info) {
                var selectionState,
                    pluginOptions = PluginHelper.getCurrentPluginOptions();

                // as soon as you change the org, filter selections *and*
                // all data views are invalid, so we should mask them.
                this.view.maskContentForLoading();

                // if this is MMR or some other plugins that takes separate
                // parameters rather than a single org ID, we have to ask the view
                // to split the orgID apart into its constituent parts and put them
                // in hidden fields.
                this.view.splitOrgID();

                // grab the selection state so we can restore it after the refresh
                selectionState = this.view.getConfigSelections();

                // reload and refresh filter(s) & demographic categories. fetch the
                // data source with the new org. when the fetch is done, update the
                // filter menus and unmask them. all data views should automatically
                // unmask themselves when they see their data has been refreshed.

                this.loadReportFilterSources(info.orgID)
                    .then(function () {
                        this.view.updateFilterMenus(selectionState);

                        // new: show the filters and demo cats; they may have been
                        // hidden if no org was selected.
                        this.view.drawerView.showFiltersAndDemoCats();
                        this.view.updateSummary();
                        return this.loadReportDataSources();
                    }.bind(this))
                    .then(function () {
                        this.view.unmaskContentForLoading();
                    }.bind(this))
                    .then(null, Util.reportPromiseException);

                if (pluginOptions.closeDrawerAfterOrgSelection) {
                    this.view.closeDrawer();
                }
                // this lets the main workspace controller know it needs to refresh the URL
                Backbone.trigger("orgChanged");
                this.view.unmaskContentForLoading();
            },

            /** Event handler: Report has changed; we must hollow out the data box
             * to make room for all-new panes, transfer filter selections to any
             * corresponding filters of the new report, destroy all pane views, and
             * re-render contents. Panes are responsible for destroying any views
             * they contain. They destroy only their memory and event handlers,
             * though; the HTML will get wiped all at once, by the DataBoxView, so
             * we don't get bogged down in a series of reflows.
             *
             * If we're reconstructing a workspace, we have less work to do.
             * @returns {Promise}
             */

            onReportSet: function () {
                var self = this,
                    org = self.view.getOrg(),
                    currentSettings = self.view.getConfigParams();
                  //  console.log(currentSettings);
                currentSettings.FISCAL_YEAR = "";
                currentSettings.year = "";
                currentSettings.subject = "";
                currentSettings.grade = "";
                currentSettings.categories = "";
                currentSettings.nscomparisonline = "";
                self.view.maskForLoading(false);

                // hydrate the NEW data source info objects into real, working
                // Backbone Models
                setTimeout(function () {
                    self.prepareDataAndFilterSources();

                    // if necessary, set the default org
                    if (!org) {
                        org = self.setDefaultOrg();
                    }

                    try {
                        self.view.createPaneViews();
                    } catch (err) {
                        if (location.hash.indexOf("mySchool") > -1)
                            location.href = location.origin;
                        setTimeout(function () {
                            location.reload(true);
                        }, 500);
                    }

                    // reload the filters and demo cats data
                    return self.loadReportFilterSources(org.orgID)
                        .then(function () {
                            // Once the filter / democat data is loaded, it's time to
                            // rebuild the config UI. this just updates the demo cats
                            // and filters views

                            self.view.updateConfigDrawerView();
                            
                            self.view.setFilterState(currentSettings);
                            self.view.updateSummary();

                            // then, once the filter UI is reconstructed, we can reload
                            // the report data sources.
                            return self.loadReportDataSources();
                        })
                        .then(function () {
                            // once that's done, we can umask the whole data box and
                            // start building it out.

                            self.view.unmaskForLoading();
                        })
                        .catch(Util.reportPromiseException);

                }, 1000);
                this.view.unmaskForLoading();
            },

            // ACTIONS
            setViewStateFromParams: function (params) {
                var datum2 = '{ name: "Statewide", type: "99", value: "Statewide", orgID: "999999000", isCharterDistrict: false, tokens: Array[2], schoolCount: 784, groupType: "state" }';

                if (params.orgId) {
                    var orgs = (CommonDataSources.entities || this.filterSources.orgs),
                        datum = orgs.getDatumFromOrgID(params.orgId),
                        openPanesArray = Util.Data.bitmaskToPositionArray(params.p);

                    // org
                    if (datum) {
                        this.view.setOrg(datum);
                    } else {
                        // this.setNoOrg();
                        this.view.setOrg(datum2);
                    }

                    if (params.FISCAL_YEAR) {
                        //
                    } else {
                        params.FISCAL_YEAR = "2021";
                    }

                    // panes
                    this.view.setPaneState(openPanesArray);

                    // filters
                    this.view.setFilterState(params);

                    // we might need to swap out an entire pane based on filter
                    // conditions.
                    this.view.updatePaneViews();

                    // definitely, we should update the summary.
                    this.view.updateSummary();
                } else {
                    this.view.setOrg(datum2);
                }
            },

            setNoOrg: function () {
                // hide the filters and demo cats until we're ready for them.
                this.view.drawerView.hideFiltersAndDemoCats();

                // set an error state
                this.setDataErrorViewState([{
                    type: "notLoaded",
                    message: "<span class='msg_you'>You haven't selected a school yet. Click or tap \"Search to find your school\" above to find your school.</span>"
                }]);
            },

            /** instatiates the selected report's data sources and saves
             * them in a hash */
            prepareDataAndFilterSources: function () {
                var reportDataSources = PluginHelper.getCurrentPluginDataSources();
                var reportFilterSources = PluginHelper.getCurrentPluginFilterSources();

                this.filterSources = {};
                this.dataSources = {};

                // loop over every enabled data source provided by the
                // report info object and fire them up
                _(reportDataSources).each(function (source, sourceName) {
                    if (source instanceof Models.Model || source instanceof Collections.Collection) {
                        // it's a pointer to an instantiated data source, just shove
                        // it into the databox
                        this.dataSources[sourceName] = source;
                    } else {
                        // it's not a pointer to an instantiated data source, it's a
                        // data source info object, so let's use it to fire one up.
                        if (source.enabled) {
                            this.dataSources[sourceName] = Util.Data.instantiateSource(source);
                        }
                    }
                }, this);

                // now, the filters
                _(reportFilterSources).each(function (source, sourceName) {
                    if (source instanceof Models.Model || source instanceof Collections.Collection) {
                        // it's a pointer to an instantiated data source, just shove
                        // it into the databox
                        this.filterSources[sourceName] = source;
                    } else {
                        // it's not a pointer to an instantiated data source, it's a
                        // data source info object, so let's use it to fire one up.
                        if (source.enabled) {
                            this.filterSources[sourceName] = Util.Data.instantiateSource(source);
                        }
                    }
                }, this);

                this.filterSources = _.extend(this.filterSources, window.workspace.getPreparedSharedFilterSources());
            },

            setDefaultOrg: function () {
                // org is this way to be backwards-compatible with RC's org list
                // loader -- it doesn't yet have a getStateOrg method
                var orgs = (this.filterSources.orgs),
                    org = orgs.getStateOrg();

                this.view.setOrg(org);
                return org;
            },

            setDataErrorViewState: function (dataErrors) {
                // the data box view has not necessarily been created yet.
                if (this.view) {
                    if (dataErrors.length > 0) {
                        // ugh, do we really have to do this so statefully?
                        this.view.dataErrors = dataErrors;
                        this.view.$el.addClass("hasDataErrors");
                        this.view.getErrorPaneView().renderContents(true);
                    } else {
                        delete this.view.dataErrors;
                        this.view.$el.removeClass("hasDataErrors");
                    }
                }
            },

            setExportButton: function (that) {
              //  console.log("SET EXPORT BUTTON");
                _.delay(function () {

                    var params = that.dataSources.data.params;
                    var categories, categoriesHash = {};

                    _(params).each(function (value, name) {
                        if (_(value).isArray()) {
                            categories = value;
                            delete params[name];
                        }
                    });

                    if (categories) {
                        _(categories).each(function (category, i) {

                            if (i == 0)
                                categoriesHash["categories"] = category;
                            else
                                categoriesHash["categories"] += "|" + category;
                        });
                        params = _(params).extend(categoriesHash).value();
                    }
                    var t, string;
                    //console.log(that.view.$el[0]);
                  
                    t = that.view.$el[0].children[3];
                    string = "<a href='" + that.dataSources.data.url + "&" + jQuery.param(params) + "&outputFormat=XLSX' data-role='button' target='_blank' class='ui-link ui-btn ui-shadow ui-corner-all' role='button'>Download All Data</a>";
                    string = string.replace('|', '%7C');

                    if (that.dataSources.data.url.indexOf("stayingInAndCompletingCollege") > -1) {
                        string = string.replace('orgId', 'HSGRAD_ORGID');
                        t.children[5].children[2].children[0].children[0].innerHTML = string;
                    } else if (that.dataSources.data.url.indexOf("collegeActivity") > -1) {
                        string = string.replace('orgId', 'HSGRAD_ORGID');
                        t.children[5].children[2].children[0].children[0].innerHTML = string;
                    } else if (that.dataSources.data.url.indexOf("deveducation") > -1) {
                        t.children[6].children[2].children[0].children[0].innerHTML = string;
                    } else if (that.dataSources.data.url.indexOf("hsgrademployment") > -1) {
                        string = string.replace('hsGradEmploymentCOHORTID', 'COHORTID');
                        t.children[3].children[2].children[0].children[0].innerHTML = string;
                    } else if (that.dataSources.data.url.indexOf("outstatecollege") > -1) {
                        t.children[10].children[2].children[0].children[0].innerHTML = string;
                    }else if (that.dataSources.data.url.indexOf("PSXfer") > -1) {
                        string = string.replace('orgId', 'PS_ORGID');
                        t.children[3].children[2].children[0].children[0].innerHTML = string;
                    } else if (that.dataSources.data.url.indexOf("abeEducationOutcomes") > -1) {
                        t.children[5].children[2].children[0].children[0].innerHTML = string;
                    } else if (that.dataSources.data.url.indexOf("newcollegestudentdemographics") > -1) {
                        string = string.replace('orgId', 'PS_ORGID');
                        t.children[7].children[2].children[0].children[0].innerHTML = string;
                    } else if (that.dataSources.data.url.indexOf("newcollegestudentenrollment") > -1) {
                        string = string.replace('orgId', 'PS_ORGID');
                        t.children[5].children[2].children[0].children[0].innerHTML = string;
                    } else if (that.dataSources.data.url.indexOf("collegegraduates") > -1) {
                        string = string.replace('orgId', 'PS_ORGID');
                        t.children[5].children[2].children[0].children[0].innerHTML = string;
                    } else if (that.dataSources.data.url.indexOf("myschool") > -1) {
                      /*   $("#mySchExport").remove();
                        string = "<p id='mySchExport'><a href='/ibi_apps/WFServlet?IBIAPP_app=rptcard_reports&IBIF_ex=rptcard_getdata_myschool_pdf&" + jQuery.param(params) + "' data-role='button' target='_blank' class='ui-link ui-btn ui-shadow ui-corner-all' role='button'>PDF Version</a></p>";
                        $(".ui-collapsible-content").first().prepend(string); */
                    }
                    // }
                }, 3500);
            },

            setFilterSourceParamsFromView: function (filterSources) {
                if (this.view) {
                    var params = this.view.getConfigSelections();

                    _(filterSources)
                        .filter(function (filterSource) {
                            return (filterSource.dataSourceInfo.noViewParams !== true);
                        })
                        .invoke("setParams", {
                            orgId: params.orgId,
                            groupType: params.groupType,
                            FISCAL_YEAR: params.FISCAL_YEAR,
                            ECO_DEV_REGION: params.ECO_DEV_REGION,
                            ECODEVREGION: params.ECODEVREGION
                        });
                }
            },

            loadReportFilterSources: function (orgId) {

                var filterRequestPromises;
                var params = this.view.getConfigParams();
        
                var year = "2021";
                var str = location.hash;
                var str2 = location.host;
                console.log("loadReportFilterSources");
                if (!params.FISCAL_YEAR) {
                    if (location.hash.indexOf("FISCAL_YEAR--") > 0) {
                        if (this.index == 0) {

                            params.FISCAL_YEAR = location.hash.substring(location.hash.indexOf("FISCAL_YEAR--") + 13, location.hash.indexOf("FISCAL_YEAR--") + 17);

                        } else {
                            if (str.length > 1)
                                str = str.split("FISCAL_YEAR--").slice(this.index);
                            if (str[this.index] != null) {
                                params.FISCAL_YEAR = str[this.index].substring(0, 4);
                            }

                        }
                    } else if (location.hash.indexOf("COHORTID--") > 0) {
                        if (this.index == 0) {

                            params.FISCAL_YEAR = location.hash.substring(location.hash.indexOf("COHORTID--") + 10, location.hash.indexOf("COHORTID--") + 14);

                        } else {
                            if (str.length > 1)
                                str = str.split("COHORTID--").slice(this.index);
                            if (str[this.index] != null) {
                                params.FISCAL_YEAR = str[this.index].substring(0, 4);
                            }

                        }
                    } else {
                        params.FISCAL_YEAR = "2021";
                    }

                    if (params.FISCAL_YEAR == "")
                        params.FISCAL_YEAR = "2021";
                }

                if (str2.indexOf("sleds") > -1) {
                    str = location.hash;

                    if (!params.ECODEVREGION) {

                        if (location.hash.indexOf("ECODEVREGION--") > 0) {
                            if (this.index == 0) {
                                params.ECO_DEV_REGION = location.hash.substring(location.hash.indexOf("ECO_DEV_REGION--") + 16, location.hash.indexOf("FISCAL_YEAR--") - 2);

                            } else {
                                str = str.split("ECO_DEV_REGION--").slice(this.index);

                                if (str[this.index] != null) {
                                    params.ECO_DEV_REGION = str[this.index].substring(0, 2);
                                }
                            }
                        }
                        if (params.ECODEVREGION == "FO")
                            params.ECODEVREGION = "FOC_NONE";
                    }

                    if (!orgId && params.ECODEVREGION == "FOC_NONE")
                        orgId = params.orgId;

                    if (params.ECODEVREGION == "FOC_NONE") {
                        _(this.filterSources)
                            .reject(function (source) {
                                return source.isCat;
                            })
                            .invoke("setParams", {
                                orgId: orgId,
                                FISCAL_YEAR: params.FISCAL_YEAR,
                            });
                    } else if (location.hash.indexOf("abeEducationOutcomes") < 0) {
                        _(this.filterSources)
                            .reject(function (source) {
                                return source.isCat;
                            })
                            .invoke("setParams", {
                                orgId: orgId,
                                FISCAL_YEAR: params.FISCAL_YEAR,
                                ECODEVREGION: params.ECODEVREGION
                            });
                    }

                } 
                else if (str2.indexOf("eclds") > -1) {
                    str = location.hash;

                    if (!params.ECO_DEV_REGION) {
                        if (location.hash.indexOf("ECO_DEV_REGION--") > -1) {
                            if (this.index == 0) {
                                // console.log(location.hash);
                                params.ECO_DEV_REGION = location.hash.substring(location.hash.indexOf("ECO_DEV_REGION--") + 16, location.hash.indexOf("FISCAL_YEAR--") - 2);
                                //  console.log(params.ECO_DEV_REGION);
                            } else {
                                str = str.split("ECO_DEV_REGION--").slice(this.index);

                                if (str[this.index] != null) {
                                    params.ECO_DEV_REGION = str[this.index].substring(0, 2);
                                }
                            }
                            if (params.ECO_DEV_REGION == "FO")
                                params.ECO_DEV_REGION = "FOC_NONE";
                        } else {
                            params.ECO_DEV_REGION = "FOC_NONE";
                        }

                    }

                    if (!orgId && params.ECO_DEV_REGION == "FOC_NONE")
                        orgId = params.orgId;
                    if (params.ECO_DEV_REGION == "FOC_NONE") {
                        _(this.filterSources)
                            .reject(function (source) {
                                return source.isCat;
                            })
                            .invoke("setParams", {
                                orgId: orgId,
                                FISCAL_YEAR: "2021",
                            });
                    } else {
                        _(this.filterSources)
                            .reject(function (source) {
                                return source.isCat;
                            })
                            .invoke("setParams", {
                                orgId: orgId,
                                FISCAL_YEAR: "2021",
                                ECO_DEV_REGION: params.ECO_DEV_REGION
                            });
                    }
                }
                else {
                  
                    if (!orgId)
                        orgId = params.orgId;
                    _(this.filterSources)
                        .reject(function (source) {
                            return source.isCat;
                        })
                        .invoke("setParams", {
                            orgId: orgId,
                            FISCAL_YEAR: params.FISCAL_YEAR,
                        });

                }
       
                if (this.dataSources.data.url.indexOf("newcollegestudentdemographics") > -1 || this.dataSources.data.url.indexOf("newcollegestudentenrollment") > -1 || this.dataSources.data.url.indexOf("collegegraduates") > -1 || this.dataSources.data.url.indexOf("electivesToACTResults") > -1 || this.dataSources.data.url.indexOf("collegeActivity") > -1 || this.dataSources.data.url.indexOf("highSchoolAcademics") > -1 || this.dataSources.data.url.indexOf("stayingInAndCompletingCollege") > -1 || this.dataSources.data.url.indexOf("deveducation") > -1 || this.dataSources.data.url.indexOf("hsgrademployment") > -1 || this.dataSources.data.url.indexOf("outstatecollege")  ) {

                    if (this.dataSources.data.url.indexOf("newcollegestudentdemographics") > -1) {
                        year = params.newCollegeStudentDemographicsCOHORTID;
                        if ((year === undefined) && (str.indexOf("newCollegeStudentDemographicsCOHORTID--") > 0)) {
                            str = location.hash;
                            year = str.substring(str.indexOf("newCollegeStudentDemographicsCOHORTID--") + 39, str.indexOf("newCollegeStudentDemographicsCOHORTID--") + 43);
                        }
                        if (location.hash.length > 200) {
                            str = location.hash;
                            str = str.split("newCollegeStudentDemographicsCOHORTID--");
                            if (str[this.index + 1] != null) {
                                year = str[this.index + 1].substring(0, 4);
                            }
                        }
                    } else if (this.dataSources.data.url.indexOf("newcollegestudentenrollment") > -1) {
                        year = params.newCollegeStudentEnrollmentCOHORTID;
                        if ((year === undefined) && (str.indexOf("newCollegeStudentEnrollmentCOHORTID--") > 0)) {
                            str = location.hash;
                            year = str.substring(str.indexOf("newCollegeStudentEnrollmentCOHORTID--") + 37, str.indexOf("newCollegeStudentEnrollmentCOHORTID--") + 41);
                        }
                        if (location.hash.length > 200) {
                            str = location.hash;
                            str = str.split("newCollegeStudentEnrollmentCOHORTID--");
                            if (str[this.index + 1] != null) {
                                year = str[this.index + 1].substring(0, 4);
                            }
                        }
                    } else if (this.dataSources.data.url.indexOf("collegegraduates") > -1) {
                        year = params.collegeGraduatesCOHORTID;
                        if ((year === undefined) && (str.indexOf("collegeGraduatesCOHORTID--") > 0)) {
                            str = location.hash;
                            year = str.substring(str.indexOf("collegeGraduatesCOHORTID--") + 26, str.indexOf("collegeGraduatesCOHORTID--") + 30);
                        }
                        if (location.hash.length > 200) {
                            str = location.hash;
                            str = str.split("collegeGraduatesCOHORTID--");
                            if (str[this.index + 1] != null) {
                                year = str[this.index + 1].substring(0, 4);
                            }
                        }
                    } else if (this.dataSources.data.url.indexOf("highSchoolAcademics") > -1) {
                        year = params.COHORTID;
                        if ((year === undefined) && (str.indexOf("__COHORTID--") > 0)) {
                            str = location.hash;
                            year = str.substring(str.indexOf("__COHORTID--") + 12, str.indexOf("__COHORTID--") + 16);
                        }
                        if (location.hash.length > 200) {
                            str = location.hash;
                            str = str.split("__COHORTID--");
                            if (str[this.index + 1] != null) {
                                year = str[this.index + 1].substring(0, 4);
                            }
                        }
                    } else if (this.dataSources.data.url.indexOf("electivesToACTResults") > -1) {
                        year = params.electivesToACTResultsCOHORTID;
                        if ((year === undefined) && (str.indexOf("electivesToACTResultsCOHORTID--") > 0)) {
                            str = location.hash;
                            year = str.substring(str.indexOf("electivesToACTResultsCOHORTID--") + 31, str.indexOf("electivesToACTResultsCOHORTID--") + 35);
                        }
                        if (location.hash.length > 200) {
                            str = location.hash;
                            str = str.split("electivesToACTResultsCOHORTID--");
                            if (str[this.index + 1] != null) {
                                year = str[this.index + 1].substring(0, 4);
                            }
                        }
                    } else if (this.dataSources.data.url.indexOf("collegeActivity") > -1) {
                        year = params.collegeActivityCOHORTID;
                        if ((year === undefined) && (str.indexOf("collegeActivityCOHORTID--") > 0)) {
                            str = location.hash;
                            year = str.substring(str.indexOf("collegeActivityCOHORTID--") + 25, str.indexOf("collegeActivityCOHORTID--") + 29);
                        }
                        if (location.hash.length > 200) {
                            str = location.hash;
                            str = str.split("collegeActivityCOHORTID--");
                            if (str[this.index + 1] != null) {
                                year = str[this.index + 1].substring(0, 4);
                            }
                        }
                    } else if (this.dataSources.data.url.indexOf("stayingInAndCompletingCollege") > -1) {
                        year = params.completingCollegeCOHORTID;
                        if ((year === undefined) && (str.indexOf("completingCollegeCOHORTID--") > 0)) {
                            str = location.hash;
                            year = str.substring(str.indexOf("completingCollegeCOHORTID--") + 27, str.indexOf("completingCollegeCOHORTID--") + 31);
                        }
                        if (location.hash.length > 200) {
                            str = location.hash;
                            str = str.split("completingCollegeCOHORTID--");
                            if (str[this.index + 1] != null) {
                                year = str[this.index + 1].substring(0, 4);
                            }
                        }
                    }
                    else if (this.dataSources.data.url.indexOf("hsgrademployment") > -1) {
                        year = params.hsGradEmploymentCOHORTID;
                        if ((year === undefined) && (str.indexOf("hsGradEmploymentCOHORTID--") > 0)) {
                            str = location.hash;
                            year = str.substring(str.indexOf("hsGradEmploymentCOHORTID--") + 15, str.indexOf("hsGradEmploymentCOHORTID--") + 19);
                        }
                        if (location.hash.length > 200) {
                            str = location.hash;
                            str = str.split("hsGradEmploymentCOHORTID--");
                            if (str[this.index + 1] != null) {
                                year = str[this.index + 1].substring(0, 4);
                            }
                        }
                    }
                    else if (this.dataSources.data.url.indexOf("deveducation") > -1) {
                        year = params.devEdCOHORTID;
                        if ((year === undefined) && (str.indexOf("devEdCOHORTID--") > 0)) {
                            str = location.hash;
                            year = str.substring(str.indexOf("devEdCOHORTID--") + 15, str.indexOf("devEdCOHORTID--") + 19);
                        }
                        if (location.hash.length > 200) {
                            str = location.hash;
                            str = str.split("devEdCOHORTID--");
                            if (str[this.index + 1] != null) {
                                year = str[this.index + 1].substring(0, 4);
                            }
                        }
                    } else if (this.dataSources.data.url.indexOf("outstatecollege")) {
                        year = params.outStateCollegeCOHORTID;

                        if ((year === undefined) && (str.indexOf("outStateCollegeCOHORTID--") > 0)) {
                            str = location.hash;
                            year = str.substring(str.indexOf("outStateCollegeCOHORTID--") + 25, str.indexOf("outStateCollegeCOHORTID--") + 29);
                        }
                        if (location.hash.length > 200) {
                            str = location.hash;
                            str = str.split("outStateCollegeCOHORTID--");
                            if (str[this.index + 1] != null) {
                                year = str[this.index + 1].substring(0, 4);
                            }
                        }

                    } else if (location.hash.length > 10) {
                        str = location.hash;
                        str = str.split("COHORTID--").slice(this.index);

                        if (str[this.index] != null) {
                            if (this.index == 0)
                                year = str[this.index + 1].substring(0, 4);
                            else
                                year = str[this.index].substring(0, 4);
                        }
                    }

                    if (this.filterSources.demographicCategories) {
                        this.filterSources.demographicCategories.params = {
                            COHORTID: year,
                            outStateCollegeCOHORTID: year,
                        };
                    }
                }

                // make the requests, and gather their promises
                filterRequestPromises = _(this.filterSources)
                    .omit(function (source) {
                        return source.dataSourceInfo.noViewParams;
                    })
                    .invoke("fetch")
                    .value();

                filterRequestPromises = filterRequestPromises.concat(
                    _(this.filterSources)
                    .pick(function (source) {
                        return source.dataSourceInfo.noViewParams;
                    })
                    .pluck("requestDonePromise")
                    .value()
                );

                // if any came back with errors, we should update the GUI to say so.
                return (this.filtersLoadedPromise = Promise.all(filterRequestPromises));
            },

            /** got a new org selected? user has changed some filter
             * setting or what have you? call this, or it's all for
             * naught */
            loadReportDataSources: function () {
                var requests = [],
                    self = this,
                    dataSources = this.dataSources;

                this.exportDone = false;

                // mark the databox has having had data loaded (this is here only
                // because of the noDefaultOrg plugin option in My School)
                this.dataLoaded = true;

                // clear the error state, error pane should disappear. fixes issue
                // wherein chart would draw while non-error panes were still hidden,
                // leading to wrong-width charts
                this.setDataErrorViewState([]);

                _(dataSources).each(function (reportData) {
                    reportData.wipe();
                    if (this.view) {
                        var configParams = this.view.getConfigParams();
                 //       configParams.year = "2022";
                 if(configParams.groupType == null)   
                        configParams.groupType = "school";
                 console.log(configParams);

                        if (configParams.FISCAL_YEAR != null)
                            this.view.setFY(configParams.FISCAL_YEAR);
                     //   if (configParams.year != null)
                         //   this.view.setFY("2022");
                        this.view.updateFilterMenus();

                        Backbone.trigger("filterChanged");

                        if (reportData.url.indexOf("NAEP") > -1) {
                            reportData.url = "/api/NAEP/" + configParams.orgId + "/" + configParams.groupType + "/" + configParams.subject + "/" + configParams.year + "/" + configParams.grade + "/";

                            if (configParams.categories && configParams.categories.length) {
                                if (Array.isArray(configParams.categories)) {
                                    $.each(configParams.categories, function (key, value) {
                                        reportData.url += value + "|";
                                    });
                                    reportData.url = reportData.url.slice(0, -1);
                                } else
                                    reportData.url += configParams.categories;
                            } else {
                                reportData.url += "All";
                            }
                        } else if (reportData.url.indexOf("DIRSSuspension") > -1) {
                            reportData.url = "/api/DIRSSuspension/" + configParams.orgId + "/" + configParams.groupType + "/" + configParams.year + "/";

                            if (configParams.categories && configParams.categories.length) {
                                if (Array.isArray(configParams.categories)) {
                                    $.each(configParams.categories, function (key, value) {
                                        reportData.url += value + "|";
                                    });
                                    reportData.url = reportData.url.slice(0, -1);
                                } else
                                    reportData.url += configParams.categories;
                            } else {
                                reportData.url += "All";
                            }
                        } else if (reportData.url.indexOf("DIRSExpulsion") > -1) {
                            reportData.url = "/api/DIRSExpulsion/" + configParams.orgId + "/" + configParams.groupType + "/" + configParams.year;

                        } else if (reportData.url.indexOf("DIRSViolentIncidents") > -1) {
                            reportData.url = "/api/DIRSViolentIncidents/" + configParams.orgId + "/" + configParams.groupType + "/" + configParams.year;
                        } else if (reportData.url.indexOf("DIRSLawEnforcementReferred") > -1) {
                            reportData.url = "/api/DIRSLawEnforcementReferred/" + configParams.orgId + "/" + configParams.groupType + "/" + configParams.year + "/";

                            if (configParams.categories && configParams.categories.length) {
                                if (Array.isArray(configParams.categories)) {
                                    $.each(configParams.categories, function (key, value) {
                                        reportData.url += value + "|";
                                    });
                                    reportData.url = reportData.url.slice(0, -1);
                                } else
                                    reportData.url += configParams.categories;
                            } else {
                                reportData.url += "All";
                            }
                        } else {
                            reportData.setParams(configParams);
                        }
                    }
                    requests.push(reportData.fetch());
                }.bind(this));

                // return a promise that resolves when all data source requests are done
                return Promise.all(requests)
                    .then(function () {
                        self.setExportButton(self);
                        self.exportDone = true;
                        // request successful, but the data may still indicate an error

                        /*           if (self.dataSources.orgDetail.params.groupType == "state") {
                                       self.view.paneViews[6].$el.hide();
                                   } else {
                                       self.view.paneViews[6].$el.show();
                                   }*/
                        self.setDataErrorViewState(self.getAllDataErrors());
                    }, function () {
                        // request not successful, there was an er
                        //      console.log("error for sure");
                        self.setDataErrorViewState(self.getAllDataErrors());
                    })
                    .then(null, Util.reportPromiseException);
            },

            /** execute filter actions: these are actions specified in the plugin
             * that have to be taken automatically when the a filter is
             * set. currently, the only supported action is the setting of a value
             * in another form field.
             * @param {Object} eventInfo the information object passed along by the
             * filterChanged or filterChangedAutomatically events, which come from
             * the DataBoxView object */
            executeFilterActions: function (eventInfo) {
                // we only deal with filter menus, not the demographic category
                // buttons...for now.
                if (!eventInfo.menuElement) {
                    return;
                }

                var selection = eventInfo.selection;

                _(eventInfo.menuData.actions).each(function (action) {
                    if (action.displayNameIs && selection.displayName === action.displayNameIs) {
                        this.executeFilterAction(action);
                    }
                    if (action.displayNameIsNot && selection.displayName !== action.displayNameIsNot) {
                        this.executeFilterAction(action);
                    }
                }.bind(this));
            },
            /** execute a single filter action. called by a loop in
             * executeFilterActions().
             * @param {Object} action the single action object given in the plugin
             */
            executeFilterAction: function (action) {

                if (action.set) {
                    _(action.set).each(function (value, subjectName) {
                        if (_.isObject(value)) {
                            // this is to accomodate getting a value from a field
                            if (value.valueOfFilter) {
                                value = this.view.getFilterValue(value.valueOfFilter);
                            }
                        }
                        this.view.setFilterValue(subjectName, value);
                    }.bind(this));
                }
            },

            // INFO METHODS
            getChartableSourcesWithNoDefaultParams: function () {
                return _(this.dataSources)
                    .reject(function (source) {
                        return !!source.defaultParams;
                    })
                    .value();
            },
            getAllDataErrors: function () {
                return _(this.dataSources).pluck("dataError").compact().value();
            }
        });

        return DataBoxController;
    });
